import {collection, doc, getDoc, getDocs, getFirestore, query, updateDoc, where, increment, arrayRemove} from "firebase/firestore";
import {app} from "../../libs/Firebase";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import {Suspense} from "react";

let executingUsersPromise;
const db = getFirestore(app);
const id = sessionStorage.getItem('adminTID');
const tname = sessionStorage.getItem('tname');
const key = sessionStorage.getItem('key')
const entryUserCollectionRef = collection(db, 'entries/'+id+"/entries");
const getAllUsers = async () => {
    const q = query(entryUserCollectionRef, where('confirmed', '==', false), where('isDeny', '==', false));
    let all = [];
    try {
        const querySnapshot = await getDocs(q);
        querySnapshot.docs.map((doc) => {
            const data = doc.data();
            const d = {
                name: data.name,
                discordId: data.discord,
                gameId: data.gameId,
                confirmed: data.confirmed,
                gameName: data.gameName,
                isDeny: data.isDeny,
                teamSize: data.teamSize,
                teamMember: data["teamMember"]
            };
            all.push(d);
            return d;
        })
        return all;
    } catch (error) {
        return Promise.reject(error);
    }
}
class PromiseWrapper{
    #state;
    constructor(promise:Promise) {
        const p = promise.then((result) => {
            this.#state = {
                type: "fulfilled",
                result: result
            };
            return result;
        }).catch((e)=>{
            this.#state = {
                type: "rejected",
                error: e
            };
            throw e;
        });
        this.#state ={
            type:"pending",
            promise: p
        };
    }
    get(){
        switch (this.#state.type) {
            case "pending": {
                throw this.#state.promise;
            }
            case "fulfilled": {
                return this.#state.result;
            }
            case "rejected": {
                throw this.#state.error;
            }
        }
    }
}
function fetchUsers(){
    if (!executingUsersPromise){
        executingUsersPromise = new PromiseWrapper(getAllUsers());
    }
    return executingUsersPromise.get();
}
function SuspendedComponent() {
    const users = fetchUsers();
    let name;
    let discord;
    let gameId;
    let gameName;
    let teamMember;
    let members;
    const Users = () => {
        const a = users.map((user,index) => {
            name = user.name;
            discord = user.discordId;
            gameId = user.gameId;
            gameName = user.gameName;
            if (user.teamSize !== 1){
                teamMember = user.teamMember;
                members = teamMember.map((member)=>{
                    return(
                        <><br/>{member}</>
                    )
                })
            }
            return (
                <Card style={{width: '18rem', margin: "10px"}} id={index}>
                    <Card.Body>
                        <Card.Title>{name}</Card.Title>
                        <Card.Text>
                            discord:{discord}<br></br>
                            ポケポケID:{gameId}<br/>
                            ポケポケユーザー名:{gameName}<br/>
                            {members}
                            <span id={"duplicate"} hidden={true}>重複があるので却下してください</span>
                        </Card.Text>
                        <Button variant="primary" style={{marginRight: '60px'}} onClick={() => {
                            action(name, true,index)
                        }}>承認する</Button>
                        <Button variant="primary" style={{background: '#c85b5b', borderColor: '#c85b5b'}}
                                onClick={() => {
                                    action(name, false,index)
                                }}>却下する</Button>
                    </Card.Body>
                </Card>
            )
        })
        return <div style={{display: "flex", flexWrap: "wrap", justifyContent: "space-around"}}>{a}</div>
    }
    return(
        <>
            <h1 className="text-center">承認待ちのユーザー</h1>
            <p className="text-center">{tname}</p>
            <Users/>
            <Button variant="secondary" style={{marginLeft: "auto", marginRight: "auto", display: "block"}} value="戻る"
                    onClick={backHome}>戻る</Button>
        </>
    )
}

function action(n, a, i) {
    const cityRef = doc(db, "entries/"+id+"/entries/"+n);
    const users = collection(db,'users');
    const userRef = query(users,where('displayName', '==', n));
    getDoc(cityRef).then((r) => {
        if (r.data()["isDeny"] || r.data()["confirmed"]){
            window.alert("既に承認/却下されています");
            document.getElementById(i).hidden = true;
        }else{
            if (a){
                document.getElementById(i).hidden = true;
                updateDoc(cityRef,{confirmed:true}).then(() => window.alert("承認しました"))
            }else{
                getDocs(userRef).then((result)=>{
                    updateDoc(result.docs[0].ref,{
                        entriesTournament:arrayRemove(id)
                    }).then()
                })
                updateDoc(doc(db,"tournaments/"+key),{
                    now: increment(-1)
                }).then()
                document.getElementById(i).hidden = true;
                updateDoc(cityRef,{isDeny:true}).then(()=> window.alert("却下しました"))
            }
        }
    })
}

function backHome(){
    window.location.href = "/admin"
}
const AdminTournament = () => {
    return (
        <>
            <Suspense fallback={"loading..."}>
                <SuspendedComponent/>
            </Suspense>
        </>
    );
};
export default AdminTournament;